 

//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by a tool.
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

namespace Dataport.OD.ErhAnMiZuWohngeld.Accessibility {
    export class AccessibilityBase {
        Init() {
        }

        readonly AccessibilityHTMLSelector = "#AccessibilityHTML";

    }
   
    $(() => {
        const page = new AccessibilityBase();
        page.Init();
    });
}



